import PropTypes from 'prop-types'
import { Popover, PopoverContent, PopoverTrigger } from '@components/ui/popover'

export const AdasPopover = ({
  trigger,
  children,
  open,
  onOpen,
  onClose,
  className,
  anchorOrigin,
  transformOrigin,
  anchorEl,
  sx,
  ...props
}) => (
  <Popover
    open={open}
    onOpenChange={(isOpen) => {
      if (isOpen) onOpen?.()
      else onClose?.()
    }}
  >
    <PopoverTrigger asChild>{trigger || <span />}</PopoverTrigger>
    <PopoverContent className={className} {...props}>
      {children}
    </PopoverContent>
  </Popover>
)

AdasPopover.propTypes = {
  trigger: PropTypes.node,
  children: PropTypes.node,
  open: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  className: PropTypes.string
}
